import { useGLTF } from "@react-three/drei";
import Block from "./Block";

export default function Blocks({ crySound, laughSound, babbleSound, onBlockClick }) {
  const aBlock = useGLTF("../stageAssets/stage1/models/a-block.glb");
  const bBlock = useGLTF("../stageAssets/stage1/models/b-block.glb");
  const cBlock = useGLTF("../stageAssets/stage1/models/c-block.glb");

  return (
    <>
      <Block
        object={aBlock.scene.clone(true)}
        position={[0.5, 0, 1]}
        rotation={[0, -1.5, 0]}
        sound={crySound}
        color="red"
        onBlockClick={onBlockClick}
      />
      <Block
        object={bBlock.scene.clone(true)}
        position={[-0.9, 0.08, 1.5]}
        rotation={[0, -9, 0]}
        sound={laughSound}
        color="blue"
        onBlockClick={onBlockClick}
      />
      <Block
        object={cBlock.scene.clone(true)}
        position={[1.8, 0.08, 0.55]}
        rotation={[0, 1.35, 0]}
        sound={babbleSound}
        color="yellow"
        onBlockClick={onBlockClick}
      />
    </>
  );
}